import React from "react";

import PropTypes from "prop-types";
import { Switch, Route } from "react-router-dom";

import basicConfig from "./basicConfig";

function BasicList(props) {
  const { path } = props;

  return (
    <Switch>
      {basicConfig.map(({ items }) =>
        items.map(({ path: pathItem, List }) => (
          <Route key={pathItem} path={`${path}/${pathItem}`}>
            <List />
          </Route>
        ))
      )}
    </Switch>
  );
}

BasicList.propTypes = {
  path: PropTypes.string.isRequired,
};

export default React.memo(BasicList);
